/** Client error telemetry: uncaught errors go to our own API (same origin, time-boxed, fire-and-forget). */
import { getTgEnv } from './tg';

let sent = 0;
export function reportError(kind: string, message: string, stack?: string) {
  if (sent++ > 5) return; // never spam
  const body = JSON.stringify({ kind, message: String(message).slice(0, 500), stack: (stack ?? '').slice(0, 2000), url: location.href.replace(/#.*/, ''), platform: getTgEnv().platform, ua: navigator.userAgent.slice(0, 200) });
  fetch('/api/client-log', { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true, signal: AbortSignal.timeout(5000) }).catch(() => {});
}

export function installErrorReporting() {
  window.addEventListener('error', (e) => reportError('error', e.message, e.error?.stack));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as { message?: string; stack?: string } | undefined;
    reportError('unhandledrejection', r?.message ?? String(e.reason), r?.stack);
  });
}
